import classNames from 'classnames';
import './ContentRibbon.scss';

export interface ContentRibbonProps {
  label: string;
  size?: 'small' | 'large';
  className?: string;
}

/**
 * ContentRibbon component
 * @param label - content text
 * @param size - small or large size, default large
 */

export const ContentRibbon: React.FC<ContentRibbonProps> = ({
  label,
  size = 'large',
  className,
}) => (
  <div className={classNames('vds-content-ribbon', `vds-badge-content-ribbon-${size}`, className)}>
    <span className="vds-content-ribbon__label">{label}</span>
  </div>
);
